<template>
  <article class="card">
    <section v-if="title" class="card-title">
      <h2 class="font-bold">
        {{ title }}
      </h2>
      <slot name="actions" />
    </section>
    <section v-if="$slots.default" class="card-body">
      <slot />
    </section>
  </article>
</template>

<script lang="ts" setup>
interface Props {
  title?: string;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
.card {
  @apply w-full bg-white;
  @apply rounded-4;
  box-shadow: 0px 3px 6px rgba(44, 40, 40, 0.11);
}
.card-title {
  @apply flex justify-between items-center;
  @apply pt-5 pb-3;
  @apply border-b border-b-element-neutral;
  @apply px-card;
}
.card-body {
  @apply py-6;
  @apply px-card;
}
</style>
